import { CustomDashboardProps } from "../utils/types";
import FinancialExport from "../components/FinancialExport";

export const dashboard: CustomDashboardProps = {
    title: "Financial Export",
    charts: [],
    filters: [],
    Component: FinancialExport,
  };